export class CardIdDto {
  id: number;
}
